// GENERATED by scripts/generate-blog-posts.ts — do not edit by hand.
// Run `npm run generate-blog-posts` (or `npm run build`) to refresh.
//
// The latest posts of blog.noreja.com per language, resolved at build time so
// the blog teaser renders them in the first paint and in the prerendered HTML.

export interface BlogPost {
  title: string;
  link: string;
  pubDate: string;
  description: string;
  author?: string;
  imageUrl?: string;
}

export const blogPosts: Record<'de' | 'en', BlogPost[]> = {
  "de": [
    {
      "title": "Process Pulse: Oktober 2026",
      "link": "https://blog.noreja.com/de-de/process-pulse-oktober-2026",
      "pubDate": "Tue, 03 Nov 2026 08:00:00 GMT",
      "description": "Willkommen bei Process Pulse, unserem monatlichen Round-up zu dem, was sich in Process Management und Process Mining bewegt hat. Einmal im Monat wählen wir die Ankündigungen, Studien und Forschungserg...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-11-03-news-roundup-process-pulse-october-1.png?width=640&name=2026-11-03-news-roundup-process-pulse-october-1.png"
    },
    {
      "title": "Two for One: Wenn Workarounds zum echten Prozess werden",
      "link": "https://blog.noreja.com/de-de/wenn-workarounds-zum-prozess-werden",
      "pubDate": "Tue, 27 Oct 2026 08:00:00 GMT",
      "description": "Über die Rasenfläche fast jedes Bürogeländes läuft ein Trampelpfad, diagonal durchs Gras, dort wo der gepflasterte Weg den großen Bogen macht. Niemand hat ihn geplant, alle benutzen ihn, und der Hausm...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-10-27-two-for-one-workarounds.png?width=640&name=2026-10-27-two-for-one-workarounds.png"
    },
    {
      "title": "Quick Tips: Warum Vereinfachen schwerer ist als Hinzufügen",
      "link": "https://blog.noreja.com/de-de/warum-vereinfachen-schwerer-ist",
      "pubDate": "Tue, 20 Oct 2026 07:00:00 GMT",
      "description": "Bitte ein Team, einen Prozess zu verbessern, und du bekommst Vorschläge: ein neues Feld für die fehlende Information, eine zusätzliche Prüfung vor der Übergabe, ein Status-Update, damit alle wissen, w...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-10-20-quick-tips-simplifying-processes.png?width=640&name=2026-10-20-quick-tips-simplifying-processes.png"
    },
    {
      "title": "Business Case: Wie du Kampagnenfreigaben beschleunigst",
      "link": "https://blog.noreja.com/de-de/kampagnenfreigaben-beschleunigen",
      "pubDate": "Tue, 13 Oct 2026 07:00:00 GMT",
      "description": "Warum Kampagnenfreigaben jetzt zählen Willkommen zur neuen Ausgabe von Business Case — dem Format, in dem wir ein realistisches Unternehmen nehmen, ein Prozessproblem mit Zahlen versehen und ausrechne...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-10-13-business-case-campaign-approvals.png?width=640&name=2026-10-13-business-case-campaign-approvals.png"
    },
    {
      "title": "Two for One: Wenn Freigaben mehr kosten als sie schützen",
      "link": "https://blog.noreja.com/de-de/wenn-freigaben-mehr-kosten-als-sie-schuetzen",
      "pubDate": "Tue, 06 Oct 2026 07:00:00 GMT",
      "description": "Niemand hat je Ärger bekommen, weil er eine Freigabestufe hinzugefügt hat. Diese Asymmetrie — unsichtbare Kosten auf der einen, sichtbare Schuld auf der anderen Seite — ist der Grund, warum Freigabeke...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/.png-Aug-28-2026-07-39-57-5591-AM.png?width=640&name=.png-Aug-28-2026-07-39-57-5591-AM.png"
    },
    {
      "title": "Quick Tips: Wie du implizites Wissen in Prozesse überführst",
      "link": "https://blog.noreja.com/de-de/implizites-wissen-in-prozesse-ueberfuehren",
      "pubDate": "Tue, 29 Sep 2026 07:00:00 GMT",
      "description": "Jedes Unternehmen läuft auf Wissen, das nirgends geschrieben steht. Welcher Kunde eine Teillieferung akzeptiert und welcher zum Vorstand eskaliert. Warum die zweite Freigabe bei Aufträgen unter einem ...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/.png-4.png?width=640&name=.png-4.png"
    }
  ],
  "en": [
    {
      "title": "Two for One: Why Workarounds Become the Real Process",
      "link": "https://blog.noreja.com/en/why-workarounds-become-the-real-process",
      "pubDate": "Tue, 03 Nov 2026 11:28:06 GMT",
      "description": "There is a shortcut worn into the lawn of almost every office park, running diagonally across the grass where the paved path curves the long way around. Nobody planned it, everybody uses it, and the g...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-10-27-two-for-one-workarounds.png?width=640&name=2026-10-27-two-for-one-workarounds.png"
    },
    {
      "title": "Process Pulse: October 2026",
      "link": "https://blog.noreja.com/en/process-pulse-october-2026",
      "pubDate": "Tue, 03 Nov 2026 08:00:00 GMT",
      "description": "Welcome to Process Pulse, our monthly round-up of what moved in process management and process mining. Once a month we pick the announcements, studies and research results that matter for people who r...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-11-03-news-roundup-process-pulse-october-1.png?width=640&name=2026-11-03-news-roundup-process-pulse-october-1.png"
    },
    {
      "title": "Quick Tips: Why Simplifying Is Harder Than Adding",
      "link": "https://blog.noreja.com/en/why-simplifying-is-harder-than-adding",
      "pubDate": "Tue, 20 Oct 2026 07:00:00 GMT",
      "description": "Ask a team to improve a process and you will get suggestions: a new field to capture the missing information, an extra check before handover, a status update so everyone knows where things stand, a sh...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-10-20-quick-tips-simplifying-processes.png?width=640&name=2026-10-20-quick-tips-simplifying-processes.png"
    },
    {
      "title": "Business Case: How to Cut Campaign Approval Time",
      "link": "https://blog.noreja.com/en/cut-campaign-approval-time",
      "pubDate": "Tue, 13 Oct 2026 07:00:00 GMT",
      "description": "Why Campaign Approvals Deserve the Attention Now Welcome to this edition of Business Case, the format in which we take a realistic company, put numbers on a process problem, and calculate what doing n...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/2026-10-13-business-case-campaign-approvals.png?width=640&name=2026-10-13-business-case-campaign-approvals.png"
    },
    {
      "title": "Two for One: When Approvals Cost More Than They Protect",
      "link": "https://blog.noreja.com/en/when-approvals-cost-more-than-they-protect",
      "pubDate": "Tue, 06 Oct 2026 07:00:00 GMT",
      "description": "Nobody ever got into trouble for adding an approval step. That asymmetry — invisible cost on one side, visible blame on the other — is why approval chains only ever grow. Every incident produces a new...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/.png-Aug-28-2026-07-39-57-5591-AM.png?width=640&name=.png-Aug-28-2026-07-39-57-5591-AM.png"
    },
    {
      "title": "Quick Tips: Turning Implicit Knowledge Into Process",
      "link": "https://blog.noreja.com/en/turn-implicit-knowledge-into-processes",
      "pubDate": "Tue, 29 Sep 2026 07:00:00 GMT",
      "description": "Every organisation runs on knowledge that exists nowhere in writing. Which customer accepts a partial delivery and which one escalates to the board. Why the second approval is skipped for orders under...",
      "author": "Lukas Pfahlsberger",
      "imageUrl": "https://blog.noreja.com/hs-fs/hubfs/blog/featured-images/.png-4.png?width=640&name=.png-4.png"
    }
  ]
};
